<template>
  <div class="con-wrap">
    <el-form
      size="medium"
      :inline="true"
      ref="queryForm"
      class="query-form-inline"
    >
      <div>
        <el-form-item class="r-20">
          <el-select
            size="mini"
            v-model="queryForm.type"
            placeholder="请选择终端类型"
          >
            <el-option
              v-for="item in typeList"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="r-20">
          <el-input
            size="mini"
            v-model="queryForm.title"
            placeholder="主题"
          ></el-input>
        </el-form-item>
        <el-form-item prop="time">
          <date-picker
            :startTime="queryForm.startReleaseTime"
            :endTime="queryForm.endReleaseTime"
            @changeStart="changeStart"
            @changeEnd="changeEnd"
          >
          </date-picker>
        </el-form-item>
        <el-button
          type="primary"
          v-if="hasPerm('notice:list')"
          @click="queryNotice"
          >查询</el-button
        >
        <el-button @click="reset" v-if="hasPerm('notice:list')">取消</el-button>
      </div>
      <div style="margin-bottom:20px">
        <el-button
          v-if="hasPerm('notice:save')"
          type="primary"
          @click.native="addNotice"
          >新增</el-button
        >
      </div>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      size="mini"
      stripe
      height="560px"
    >
      <el-table-column
        width="24"
        align="center"
        style="padding:0"
      ></el-table-column>
      <el-table-column type="index" label="序号" width="260"></el-table-column>
      <el-table-column prop="type" label="终端">
        <template slot-scope="scope">
          <span
            v-for="item of typeList"
            :key="item.code"
            >
            <span  v-if="scope.row.type == item.code">{{ item.value }}</span>   
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="主题">
        <template slot-scope="scope">
          <el-button
            type="text"
            v-if="hasPerm('notice:info')"
            @click.native="noticeDetailBtn(scope.row.id)"
            >{{ scope.row.title }}</el-button
          >
          <span v-else>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="modifyName" label="内容"></el-table-column> -->
      <el-table-column prop="drafter" label="拟稿人"></el-table-column>
      <el-table-column prop="releaseTime" label="发布时间"></el-table-column>
      <el-table-column prop="expireTime" label="过期时间"></el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="queryForm.page"
      :page-size="queryForm.limit"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <!--新增用户对话框-->
    <el-dialog title="新增公告内容" :visible.sync="visibleNotice" class="mini-dialog">
      <el-form
        :rules="rules"
        ref="noticeForm"
        :model="noticeForm"
        size="mini"
        :inline="true"
        label-width="90px"
      >
        <el-form-item prop="type" label="发布终端">
          <el-select v-model="noticeForm.type" placeholder="请选择终端类型">
            <el-option
              v-for="item in typeList"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="expireTime" label="有效时间">
          <el-date-picker
            v-model="noticeForm.expireTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="请选择有效时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="releaseTime" label="发布时间">
          <el-date-picker
            v-model="noticeForm.releaseTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="请选择有效时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item class="input-area" prop="title" label="公告标题">
          <el-input
            v-model="noticeForm.title"
            placeholder="请输入公告标题"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="input-area"
          v-for="(domain, index) in noticeForm.contentList"
          :label="'公告内容' + (index > 0 ? index + 1 : '')"
          :key="index"
          :prop="'contentList.' + index + '.value'"
          :rules="{
            required: true,
            message: '公告内容不能为空',
            trigger: 'blur',
          }"
        >
          <template v-if="index == 0 || index == 2">
            <el-input
              v-model="domain.value"
              placeholder="请输入公告内容"
            ></el-input>
          </template>
          <template v-else>
            <el-input
              type="textarea"
              v-model="domain.value"
              placeholder="请输入公告内容"
            ></el-input>
            <el-button
              type="text"
              style="color:#F00"
              @click.prevent="removeDomain(domain)"
              >删除</el-button
            >
          </template>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDomain">增加公告内容</el-button>
        <el-button type="primary" @click="saveOrUpdate">确定发布</el-button>
      </span>
    </el-dialog>
    <!-- 更新公告详情 -->
    <el-dialog
      :title="noticeDetail.title"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="noticeSwitch"
      width="600px"
      center
      class="noticeSwitch"
    >
      <div>{{ user }}</div>
      <div
        v-for="(item, index) in noticeDetail.contentList"
        :key="index"
        style="text-indent:25px"
      >
        {{ item }}
      </div>
      <div>{{ sorry }}</div>
      <p style="text-align:right">杭州锦辉科技有限公司</p>
      <p style="text-align:right">{{ noticeDetail.releaseTime }}</p>
    </el-dialog>
  </div>
</template>

<script>
import DatePicker from "@/components/DatePicker.vue"
export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      noticeSwitch: false,
      noticeDetail: [],
      user: null,
      sorry: null,
      queryForm: {
        type: null,
        title: null,
        startReleaseTime: null,
        endReleaseTime: null,
        limit: 10,
        page: 1,
      },
      typeList: [],
      total: 0,
      tableVal: [],
      tableData: [],
      visibleNotice: false,
      noticeForm: {
        contentList: [],
      },
      rules: {
        type: [
          {
            required: true,
            trigger: "change",
            message: "请选择终端",
          },
        ],
        expireTime: [
          {
            required: true,
            trigger: "change",
            message: "请选择有效时间",
          },
        ],
        releaseTime: [
          {
            required: true,
            trigger: "change",
            message: "请选择发布时间",
          },
        ],
        title: [
          {
            required: true,
            trigger: "blur",
            message: "请输入标题",
          },
        ],
      },
    }
  },
  created() {
    this.getTypeList()
    this.getNoticeList()
  },
  methods: {
    // 新增按钮
    addNotice() {
      this.noticeTemplate()
      this.visibleNotice = true
      this.$resetForm(this, "noticeForm")
      
    },
    reset() {
      this.queryForm = {
        type: null,
        title: null,
        startReleaseTime: null,
        endReleaseTime: null,
        limit: 10,
        page: 1,
      }
      this.getNoticeList()
    },
    // 获取公告模板
    async noticeTemplate() {
      let _this = this
      let { data: res } = await _this.$axios.get(`/api/notice/template`)
      if (res.code == 1) {
        _this.noticeForm.contentList = []
        if (res.data && res.data.length > 0) {
          res.data.map((item) => {
            _this.noticeForm.contentList.push({
              value: item,
            })
          })
        }
      } else {
        _this.$message.warning(res.msg)
      }
    },
    // 查看公告详情
    async noticeDetailBtn(id) {
      let _this = this
      let { data: res } = await _this.$axios.get(`/api/notice/info/${id}`)
      if (res.code == 1) {
        _this.user = res.data.contentList.splice(0, 1)[0]
        _this.sorry = res.data.contentList.splice(-1, 1)[0]
        _this.noticeDetail = res.data
        _this.noticeSwitch = true
      } else {
        _this.$message.warning(res.msg)
      }
    },
    addDomain() {
      this.noticeForm.contentList.push({ value: "" })
    },
    removeDomain(item) {
      var index = this.noticeForm.contentList.indexOf(item)
      if (index !== -1) {
        this.noticeForm.contentList.splice(index, 1)
      }
    },
    //   查询终端类型
    async getTypeList() {
      let _this = this
      let { data: res } = await _this.$axios.get("/api/sys/dict/noticeType")
      if (res.code == 1) {
        _this.typeList = res.data
      } else {
        _this.$message.warning(res.msg)
      }
    },
    changeStart(val) {
      this.queryForm.startReleaseTime = val
    },
    changeEnd(val) {
      this.queryForm.endReleaseTime = val
    },
    async getNoticeList() {
      let _this = this
      let { data: res } = await _this.$axios.get("/api/notice/list", {
        params: _this.queryForm,
      })
      if (res.code == 1) {
        _this.tableData = res.data.list
        _this.total = res.data.totalCount
      } else {
        _this.$message.warning(res.msg)
      }
    },
    queryNotice() {
      this.getNoticeList()
    },
    saveOrUpdate() {
      let _this = this
      _this.$refs.noticeForm.validate(async (valid) => {
        if (valid) {
          let noticeFormContent = []
          _this.noticeForm.contentList.map((item) => {
            noticeFormContent.push(item.value)
          })
          _this.noticeForm.contentList = noticeFormContent
          let { data: res } = await _this.$axios.post(
            "/api/notice",
            _this.noticeForm
          )
          if (res.code == 1) {
            _this.$message.success("操作成功")
            _this.getNoticeList()
            _this.visibleNotice = false
          } else {
            _this.$message.warning(res.msg)
          }
        }
      })
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.queryForm.page = val
      this.getNoticeList()
    },
  },
}
</script>

<style lang="scss" scoped>
.con-wrap {
  background-color: #fff;
  padding: 0 20px;
}
.con-wrap .el-container {
  background-color: #fff;
  padding: 0 20px;
}
.query-form-inline {
  padding-top: 20px;
}
.noticeSwitch {
  line-height: 30px;
  /deep/ .el-dialog__header {
    padding: 0px;
  }
}
/deep/ .el-date-editor.el-input {
  width: 90%;
}
/deep/ .el-form .el-button {
  margin-left: 10px;
  margin-right: 0px;
}
/deep/ .el-input--mini {
  width: 90%;
}
.mini-dialog .input-area /deep/ {
  margin-bottom: 0;
  .el-textarea {
    height: auto;
  }
  .el-textarea__inner {
    min-height: 80px !important;
    max-height: 100px;
    color: #606266;
    font-size: 14px;
    font-family: none;
  }
  .el-form-item__content {
    height: auto;
  }
}
.mini-dialog /deep/ .el-dialog__body {
  padding-bottom: 0;
}
.dialog-footer {
  /deep/ .el-button {
    width: 106px;
  }
}
</style>
